import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

import { makeCsv, getTableDataForExport , getColKeyArrayObject} from 'state/actions/users';

import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Col} from 'react-bootstrap'; 

const Users = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [archive, setArchive] = React.useState([]);
  const [list, setList] = React.useState(true);
  const [colexport, setColExport] = React.useState([]);
  
  const relIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('users').doc(id).update({delete:false}).then((snap)=> {
        toast.success("L'utilisateur a été dé-archiver");
        loadUsers()
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('users').doc(id).update({delete:true}).then((snap)=> {
        toast.success("L'utilisateur a été archiver");
        loadUsers()
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };

  const del = (id) => {
    if(confirm(`Êtes vous certain de vouloir archiver l'utilisateur?`)){
      delIt(id);
    }
  }


  
  const rel = (id) => {
    if(confirm(`Êtes vous certain de vouloir dé-archiver l'utilisateur?`)){
      relIt(id);
    }
  }



  const columnsar = [
    {
      accessor: 'firstName',
      Header: 'Prénom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'lastName',
      Header: 'Nom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'email',
      Header: 'Email',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email } = rowData.row.original;
        return(
          <a href={`mailto:${email}`}>{email}</a>
        )
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { type } = rowData.row.original;
        return(<span class={`badge badge rounded-pill ${type === "admin" ? "badge-subtle-success" : "badge-subtle-warning"}`}>{type}​</span>)
      }
    },
    {
      accessor: 'phone',
      Header: 'Téléphone',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { phone } = rowData.row.original;
        return(
          <a href={`tel:${phone}`}>{phone}</a>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id, type } = rowData.row.original
        return(
          <> 
        {type !== "admin" && (
          <IconButton  onClick={() => {rel(id)}}
          variant="falcon-danger"
          size="sm"
          // icon="trash"
          transform="shrink-3"
          className='me-2'
        >
           <span className="d-none d-sm-inline-block ms-1">dé-archiver</span>
        </IconButton> 
        )}
        
</>



        )
      }
    }
  ];


  const columns = [
    {
      accessor: 'firstName',
      Header: 'Prénom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'lastName',
      Header: 'Nom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'email',
      Header: 'Email',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email } = rowData.row.original;
        return(
          <a href={`mailto:${email}`}>{email}</a>
        )
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { type } = rowData.row.original;
        return(<span class={`badge badge rounded-pill ${type === "admin" ? "badge-subtle-success" : "badge-subtle-warning"}`}>{type}​</span>)
      }
    },
    {
      accessor: 'phone',
      Header: 'Téléphone',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { phone } = rowData.row.original;
        return(
          <a href={`tel:${phone}`}>{phone}</a>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id, type } = rowData.row.original
        return(
          <>
          <IconButton  href={`/user/edit/${id}`}
          variant="falcon-default"
          size="sm"
          icon="edit"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1">modifier</span>
        </IconButton> 
        {type !== "admin" && (
          <IconButton  onClick={() => {del(id)}}
          variant="falcon-danger"
          size="sm"
          icon="trash"
          transform="shrink-3"
          className='me-2'
        >
        </IconButton> 
        )}
        
</>



        )
      }
    }
  ];

  const loadUsers = () => {
    firebase.firestore().collection('users').get().then((snap)=> {
      let s = [];
      let sarchive = [];
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        // console.log(l?.delete)
        if (l?.delete != true){
          s.push(l)
        }else{
          sarchive.push(l)
        }
        
      })
      setData(s);
      setArchive(sarchive);

      setColExport(getColKeyArrayObject(s));


    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  React.useEffect(() => {
    if (data.length === 0){
      loadUsers()
    }
  }, []);

// const data = [
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"modérateur"
//   },
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"admin"
//   },
// ];
 
 
 

function AdvanceTableExample({arch = false}) {

  return (
    <AdvanceTableWrapper
      columns={arch ? columnsar : columns}
      data={arch ? archive : data}
      sortable
      pagination
      perPage={100}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      <IconButton  href="/newuser"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouveau</span>
      </IconButton> 

      {list && data && data.length > 0 && (
              <IconButton 

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                  onClick={() => makeCsv(getTableDataForExport(data, colexport), `users-bo-house.csv`)}
  
              >
                Export des données en CSV 
                  </IconButton>)}

      <IconButton onClick={() => {setList(!list)}}
        variant="falcon-default"
        size="sm"
        icon="trash"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">{list ? "Voir les archives" : "Voir la liste"}</span>
      </IconButton> 
      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <FalconComponentCard>
        
      <FalconComponentCard.Header
        title={list ? "Liste des utilisateurs" : "Liste des utilisateurs (archive)"}
        light={false}
       
        className="border-bottom border-200" noPreview={true} 
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample arch={!list}/>
      </FalconComponentCard.Body>

        
    </FalconComponentCard>
    );
}

export default Users;
